import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "45",
  height: "45",
  viewBox: "0 0 45 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M11.8 9C9.1488 9 7 11.1824 7 13.875L7 30.125C7 32.8176 9.1488 35 11.8 35H34.2C36.8512 35 39 32.8176 39 30.125V13.875C39 11.1824 36.8512 9 34.2 9H11.8ZM11.8 12.25H32.6C32.6 15.2043 32.6 28.7958 32.6 31.75H11.8C10.9168 31.75 10.2 31.022 10.2 30.125L10.2 13.875C10.2 12.978 10.9168 12.25 11.8 12.25ZM35.8 20.375C36.6832 20.375 37.4 21.103 37.4 22C37.4 22.897 36.6832 23.625 35.8 23.625C34.9168 23.625 34.2 22.897 34.2 22C34.2 21.103 34.9168 20.375 35.8 20.375Z",
      fill: "currentColor"
    }, null, -1)
  ])))
}
export default { render: render }